<template>
  <div
    @click="viewDetails"
    class="relative shadow-md overflow-hidden my-2 rounded-xl py-2 bg-gray-50 flex items-center w-full space-x-4"
  >
    <button
      class="absolute top-0 right-0 px-2 py-1 bg-gray-200 bg-opacity-70"
      aria-label="delete cart item"
    >
      <img alt="" class="h-6 w-6" src="@/assets/icons/heartsfill.svg" />
    </button>
    <img
      v-if="imageUrl"
      alt="image"
      class="h-24 w-24 object-cover rounded-full"
      :src="imageUrl"
    />
    <img
      v-else
      alt="logo"
      class="h-24 w-24 object-fill rounded-full"
      src="@/assets/logograysquare.png"
    />
    <p class="flex-1 text-left font-medium">
      {{ $store.getters.menuItem(itemID)?.title }}
    </p>
  </div>
</template>
<script>
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
export default {
  created() {
    this.fetchCachedImage();
    if (
      this.$store.state.menu.length > 0 &&
      !this.$store.getters.menuItem(this.itemID)
    ) {
      this.$toast.show("Unavailable Menu Item Removed", {
        position: "bottom",
        duration: 2000,
      });
      this.$emit("removeItem", this.itemID);
    }
  },
  props: {
    itemID: String,
    index: String,
  },
  data() {
    return {
      imageUrl: "",
    };
  },
  methods: {
    fetchCachedImage() {
      var title = this.$store.getters.menuItem(this.itemID)?.title;
      var urlImage = this.$store.getters.menuItem(this.itemID)?.imageUrl;
      Filesystem.readFile({
        path: `menuImages/${title}`,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      })
        .then((result) => {
          this.imageUrl = result.data.slice(result.data.indexOf("data:image/"));
        })
        .catch(() => {
          this.imageUrl = urlImage;
        });
    },
    viewDetails() {
      this.$router.push({
        name: "MenuDescription",
        params: {
          menuID: this.itemID,
        },
      });
    },
  },
};
</script>
